import { FC, ReactNode } from 'react'
import cn from 'classnames'
import classes from './selectOptionColorLabel.module.css'

type SelectOptionColorLabelProps = {
  color: string
  children: ReactNode
  className?: string
}

const SelectOptionColorLabel: FC<SelectOptionColorLabelProps> = ({
  color,
  children,
  className,
}) => (
  <div className={cn(classes.wrapper, className)}>
    <span
      className={classes.dot}
      style={{ backgroundColor: color }}
      aria-hidden
    />
    <span className={classes.text}>{children}</span>
  </div>
)

export default SelectOptionColorLabel
